/* BLP Offers – sale prices on Boost collection / search cards.
 * Sale offers (dashboard "Sale · Bundle · Buy more" → Sale) are priced at checkout by the BLP Offers
 * discount function, so Shopify's own price is unchanged. This script shows the customer the sale
 * price on the product cards: red sale price, struck-through regular price and a "% OFF" ribbon.
 * Matching: product id, brand (vendor), product type, collection. Collection membership is known for
 * the collection being viewed; for others it is looked up once per product (?view=blpc) and cached. */
(function () {
  var el = document.getElementById('blp-offers-config');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  var sales = (cfg.sales || []).filter(function (s) { return Number(s.dv) > 0; });
  if (!sales.length) return;
  var curCol = cfg.col != null ? String(cfg.col) : null;
  var lc = function (s) { return String(s == null ? '' : s).toLowerCase().trim(); };
  sales.forEach(function (s) {
    s.p = (s.p || []).map(String); s.c = (s.c || []).map(String);
    s.v = (s.v || []).map(lc); s.t = (s.t || []).map(lc);
  });
  var needCols = sales.some(function (s) { return s.c.some(function (c) { return c !== curCol; }); });

  var css = '.blp-cs__ribbon{display:block;width:100%;margin:0;background:#f6e5c5;color:#9a6b0c;' +
    'font-weight:700;font-size:12px;letter-spacing:.06em;text-align:center;line-height:1;padding:7px 4px;text-transform:uppercase;pointer-events:none}' +
    '.blp-cs__prices{display:flex;flex-wrap:wrap;justify-content:center;align-items:baseline;gap:2px 8px}' +
    '.blp-cs__now{color:#171717;font-weight:700;font-size:16px}' +
    '.blp-cs__was{color:#6b6b6b;font-size:13px;font-weight:400;text-decoration:line-through}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function money(cents) {
    var d = cents / 100, whole = cents % 100 === 0;
    return '$' + d.toLocaleString('en-AU', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }
  function saving(s, cents) {
    var v = Number(s.dv) || 0;
    return s.dt === 'amt' ? Math.min(cents, Math.round(v * 100)) : Math.round(cents * v / 100);
  }
  function matches(s, inf, cols) {
    if (inf.pid && s.p.indexOf(inf.pid) > -1) return true;
    if (inf.vendor && s.v.indexOf(inf.vendor) > -1) return true;
    if (inf.type && s.t.indexOf(inf.type) > -1) return true;
    for (var i = 0; i < s.c.length; i++) {
      if (s.c[i] === curCol && inf.inCur) return true;
      if (cols && cols.indexOf(s.c[i]) > -1) return true;
    }
    return false;
  }

  // Collection ids per product handle (only needed for sales on collections other than this page's).
  var memo = {};
  try { memo = JSON.parse(sessionStorage.getItem('blpcols') || '{}'); } catch (e) { memo = {}; }
  var queue = [], busy = 0, waiting = {};
  function saveMemo() { try { sessionStorage.setItem('blpcols', JSON.stringify(memo)); } catch (e) {} }
  function colsFor(handle, cb) {
    if (memo[handle]) return cb(memo[handle]);
    (waiting[handle] = waiting[handle] || []).push(cb);
    if (waiting[handle].length === 1) { queue.push(handle); pump(); }
  }
  function pump() {
    while (busy < 2 && queue.length) {
      var h = queue.shift(); busy++;
      (function (h) {
        fetch('/products/' + encodeURIComponent(h) + '?view=blpc', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (t) {
            var cols = [];
            try { cols = (JSON.parse(t).c || []).map(String); } catch (e) {}
            memo[h] = cols; saveMemo();
            (waiting[h] || []).forEach(function (cb) { cb(cols); }); delete waiting[h];
          })
          .catch(function () { delete waiting[h]; })
          .then(function () { busy--; setTimeout(pump, 150); });
      })(h);
    }
  }

  function infoOf(card) {
    var data = {};
    try { data = JSON.parse(card.getAttribute('data-product') || '{}'); } catch (e) {}
    var t = card.querySelector('.boost-sd__product-title[id]');
    var pid = t ? t.id.replace('product-title-', '') : '';
    var ven = card.querySelector('.boost-sd__product-vendor');
    var vendor = ven ? lc(ven.textContent.replace(/^\s*Vendor:\s*/i, '')) : '';
    return {
      pid: pid, handle: data.handle, vendor: vendor, type: lc(data.category),
      price: Math.round(Number(data.priceMin) * 100), inCur: !!curCol
    };
  }

  function best(inf, cols) {
    var b = null, bs = 0;
    sales.forEach(function (s) {
      if (!matches(s, inf, cols)) return;
      var sv = saving(s, inf.price);
      if (sv > bs) { b = s; bs = sv; }
    });
    return b ? { s: b, save: bs } : null;
  }

  function paint(card, inf, hit) {
    var priceBox = card.querySelector('.boost-sd__product-price');
    if (!priceBox || !inf.price) return;
    var now = inf.price - hit.save;
    var key = hit.s.id + ':' + now;
    if (card.getAttribute('data-blp-sale') === key && priceBox.querySelector('.blp-cs__now')) return;
    card.setAttribute('data-blp-sale', key);
    priceBox.innerHTML = '<span class="boost-sd__visually-hidden">Sale price ' + money(now) + ', was ' + money(inf.price) + '</span>' +
      '<span class="blp-cs__prices" aria-hidden="true"><span class="blp-cs__now">' + money(now) + '</span>' +
      '<s class="blp-cs__was">' + money(inf.price) + '</s></span>';
    var wrap = card.querySelector('.boost-sd__product-image-wrapper');
    var img = card.querySelector('.boost-sd__product-item-grid-view-layout-image, .boost-sd__product-item-list-view-layout-image') || (wrap && wrap.parentNode);
    if (img && !card.querySelector('.blp-cs__ribbon')) {
      var r = document.createElement('div');
      r.className = 'blp-cs__ribbon';
      r.textContent = hit.s.rt || (hit.s.dt === 'amt' ? money(Math.round(Number(hit.s.dv) * 100)) + ' OFF' : String(hit.s.dv).replace(/\.0+$/, '') + '% OFF');
      if (/^#[0-9a-f]{6}$/i.test(hit.s.rb || '')) r.style.background = hit.s.rb;
      if (/^#[0-9a-f]{6}$/i.test(hit.s.rf || '')) r.style.color = hit.s.rf;
      img.parentNode.insertBefore(r, img.nextSibling);
    }
  }

  function handle(card) {
    var inf = infoOf(card);
    if (!inf.price) return;
    var hit = best(inf, null);
    if (hit) return paint(card, inf, hit);
    if (needCols && inf.handle) {
      colsFor(inf.handle, function (cols) {
        var h2 = best(inf, cols);
        if (h2) paint(card, inf, h2);
      });
    }
  }

  var t = null;
  function scan() {
    t = null;
    var cards = document.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.getAttribute('data-blp-sale') && c.querySelector('.blp-cs__now')) continue;
      handle(c);
    }
  }
  function soon() { if (!t) t = setTimeout(scan, 120); }
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
})();
